import { render, staticRenderFns } from "./FlagForm.vue?vue&type=template&id=6f09851c&scoped=true&"
import script from "./FlagForm.vue?vue&type=script&lang=js&"
export * from "./FlagForm.vue?vue&type=script&lang=js&"
import style0 from "./FlagForm.vue?vue&type=style&index=0&id=6f09851c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f09851c",
  null
  
)

export default component.exports